import { useMutation, useQuery } from 'react-query'
import { getInvoicingFunnel, refreshInvoicingFunnel } from './api'
import { FunnelPeriod } from './funnelModel'

export const useInvoicingFunnel = (period: FunnelPeriod) => {
  return useQuery({
    queryKey: ['invoicingFunnel', period],
    queryFn: () => getInvoicingFunnel(period)
  })
}

export const useInvoicingFunnelRefresh = () => {
  return useMutation({
    mutationFn: refreshInvoicingFunnel,
  })
}
